import { sha256 } from 'js-sha256'

// ==================== 文件哈希计算（流式，内存恒定）====================
// 用 js-sha256 而非原生 crypto.subtle：
// 原生 digest 需一次性把整个文件读入内存，500MB 视频会撑爆浏览器；
// js-sha256 支持 2MB 一块逐次 update，内存占用恒定。

const CHUNK_SIZE = 2 * 1024 * 1024 // 每次读 2MB

/**
 * 计算文件 SHA256 哈希（分块流式读取）
 * @param {File|Blob} file - 浏览器 File 对象
 * @param {(percent: number) => void} [onProgress] - 哈希计算进度回调（0~100）
 * @returns {Promise<string>} hex 哈希值
 */
export function calcFileHash(file, onProgress) {
    const hash = sha256.create()
    const total = file.size
    const chunks = Math.max(1, Math.ceil(total / CHUNK_SIZE))

    return (async () => {
        for (let i = 0; i < chunks; i++) {
            const start = i * CHUNK_SIZE
            const end = Math.min(start + CHUNK_SIZE, total)
            const buffer = await file.slice(start, end).arrayBuffer()
            hash.update(buffer)
            if (typeof onProgress === 'function') {
                onProgress(Math.round(((i + 1) / chunks) * 100))
            }
        }
        return hash.hex()
    })()
}
